import {
  emailSchema,
  phoneSchema,
  titleUI,
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import SponsorContactInfoPrefillCard from '../../components/FormDescriptions/SponsorContactInfoPrefillCard';
import SponsorContactInfoPrefillReview from '../../components/FormReview/SponsorContactInfoPrefillReview';
import { hiddenFieldUI } from '../../definitions';
import content from '../../locales/en/content.json';
import { CONTACT_INFO_CONFIRM_KEY } from '../../utils/helpers';

const TITLE_TEXT = content['sponsor--prefill-contact-title'];
const DESC_TEXT = content['sponsor--prefill-contact-description'];
const INPUT_LABEL = content['sponsor--prefill-contact-label'];

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    'ui:description': SponsorContactInfoPrefillCard,
    'ui:objectViewField': SponsorContactInfoPrefillReview,
    [CONTACT_INFO_CONFIRM_KEY]: yesNoUI(INPUT_LABEL),
    sponsorPhone: hiddenFieldUI,
    sponsorEmail: hiddenFieldUI,
  },
  schema: {
    type: 'object',
    required: [CONTACT_INFO_CONFIRM_KEY],
    properties: {
      [CONTACT_INFO_CONFIRM_KEY]: yesNoSchema,
      sponsorPhone: phoneSchema,
      sponsorEmail: emailSchema,
    },
  },
};
